import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVerifiedStatus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 24,
	viewBox: "0 0 22 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group 6911",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Rectangle 2329",
			d: "M0.5 2C0.5 0.89543 1.39543 0 2.5 0H19.5C20.6046 0 21.5 0.895431 21.5 2V15.9146C21.5 16.5916 21.1576 17.2226 20.59 17.5915L12.5398 22.8241C11.9028 23.2381 11.0864 23.2556 10.4323 22.8691L1.48254 17.5806C0.873596 17.2208 0.5 16.5661 0.5 15.8587V2Z",
			fill: "#0CB182"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M6.5 10.5L10.7593 14L16.5 7",
			stroke: "white",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	})
});
export default SvgVerifiedStatus;
